import React from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { APIURL, TZ } from '../../../Global';
import { useAlert } from 'react-alert';

const Confirmation = ({ group, type, id, onCancel, onSuccess }) => {
    const alert = useAlert();

    const handleConfirm = async () => {
        if ((!type || !id) && type !== 'group') {
            alert.error('ID and type are mandatory');
            return;
        }

        try {
            const tokenString = sessionStorage.getItem('usertoken');
            const token = tokenString?.replace(/["]+/g, '');

            if (!token) {
                alert.error('Authentication token missing');
                return;
            }

            const config = {
                headers: {
                    Authorization: `Token ${token}`,
                    'Content-Type': 'application/json'
                }
            };

            if (type === 'group') {
                const response = await axios.delete(`${APIURL}/api/v1/staff/hospital-group/`, {
                    data: { id: group.id },
                    headers: { Authorization: `Token ${token}` }
                  });
            
                if (response.status === 200 && response.data.status === 'success') {
                    alert.success('Group deleted successfully!');
                    onSuccess();
                } else {
                    alert.error(response.data.message || 'Failed to delete group.');
                    onCancel();
                }
            } else {
                const payload = {
                    [type === 'clinic' ? 'method' : 'policy_method']: 'remove',
                    group_id: group.id,
                    [type === 'clinic' ? 'hospital_ids' : 'sharable_policy']: [String(id)]
                };

                const endpoint = `hospital-group/?group_id=${group.id}&${TZ}`;
                const response = await axios.put(
                    `${APIURL}/api/v1/staff/${endpoint}`,
                    payload,
                    config
                );

                if (response.status === 200 && response.data.status === 'success') {
                    alert.success(`${type} removed successfully!`);
                    onSuccess();
                } else {
                    alert.error(response.data.message || `Failed to remove ${type}.`);
                    onCancel();
                }
            }
        } catch (error) {
            console.error('API Error:', error);
            if (error.response) {
                if (error.response.status === 401) {
                    alert.error('Session expired. Please login again.');
                } else {
                    alert.error(`Failed to ${type === 'group' ? 'delete' : 'remove'} ${type}. ${error.response.data.message || ''}`);
                }
            } else {
                alert.error(`Failed to ${type === 'group' ? 'delete' : 'remove'} ${type}. Please try again.`);
            }
        }
    };

    return (
        <Modal
            size="md"
            aria-labelledby="confirmation-modal"
            centered
            backdrop="static"
            keyboard={false}
            show={true}
            onHide={onCancel}
        >
            <Modal.Body style={{ display: 'flex', flexDirection: 'column' }}>
                <div><div className="alert-border"><span className="alert-icon">!</span></div></div>
                <label style={{ margin: '20px auto', color: '#4e4e4e', fontSize: '18px' }}>
                    Are you sure you want to {type === 'group' ? 'delete' : 'remove'} {type}?
                </label>
                <div className="form-group" style={{ display: 'flex', margin: 'auto' }}>
                    <button
                        type="button"
                        className='swirl-butns'
                        style={{ margin: '10px 4px 0px 0px', backgroundColor: '#dc3545' }}
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className='swirl-butns'
                        style={{ margin: '10px 0px 0px 4px', backgroundColor: '#2b69a3' }}
                        onClick={handleConfirm}
                    >
                        Confirm
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default Confirmation;